import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import Countries from "./../../../data/countries";
import './course-historu.css'
const CourseHistory = () => {
  const navigate = useNavigate();
  const handleDropdownChange = (e) => {
    if (e.target.value === "View") {
      navigate("/student-panel/courses-history/view");
    }
  };
  let State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  const [TableData, setTableData] = useState([
    {
      id: "1",
      title: "Lorem ipsum",
      des: "Lorem ipsum dolor...",
      name: "Willow Anderson",
      no: "10",
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      hr: "5h",
      status: "Complated",
    },
    {
      id: "2",
      title: "Lorem ipsum",
      des: "Lorem ipsum dolor...",
      name: "Willow Anderson",
      no: "10",
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      hr: "5h",
      status: "Cancelled",
    },
    {
      id: "3",
      title: "Lorem ipsum",
      des: "Lorem ipsum dolor...",
      name: "Willow Anderson",
      no: "10",
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      hr: "5h",
      status: "Complated",
    },
    {
      id: "4",
      title: "Lorem ipsum",
      des: "Lorem ipsum dolor...",
      name: "Willow Anderson",
      no: "10",
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      hr: "5h",
      status: "Cancelled",
    },
    {
      id: "5",
      title: "Lorem ipsum",
      des: "Lorem ipsum dolor...",
      name: "Willow Anderson",
      no: "10",
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      hr: "5h",
      status: "Complated",
    },
    {
      id: "6",
      title: "Lorem ipsum",
      des: "Lorem ipsum dolor...",
      name: "Willow Anderson",
      no: "10",
      country: "burnside",
      state: "burnside",
      date: "JAN 4, 2022",
      hr: "5h",
      status: "Cancelled",
    },
  ]);
  return (
    <SideMenu>
      <div className="page-container">
        <div className="page-header-button-main">
          <Button className="page-header-button" variant="text">
            <p className="page-header-button-text">Download</p>
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by course Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by course Name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Search by Tutor</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by tutor"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={4} sm={4} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">courses History</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="class-history-table-id-heading">ID</th>
                <th className="class-history-table-image-heading">Image</th>
                <th className="class-history-table-class-title-heading">
                  Class Title
                </th>
                <th className="class-history-table-description-heading">
                  Discription
                </th>
                <th className="class-history-table-tutors-name-heading">
                  Tutors Name
                </th>
                <th className="class-history-table-student-no-heading">
                  No. of Students
                </th>
                <th className="cours-history-table-country-name-heading">
                  Country
                </th>
                <th className="cours-history-table-state-name-heading">
                  State
                </th>
                <th className="class-history-table-date-heading">Date</th>
                <th className="class-history-table-duration-heading">
                  Total Hour
                </th>
                <th className="class-history-table-status-heading">Status</th>
                <th className="class-history-table-action-heading"></th>
              </tr>
              </thead>
              <br />
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableValue.id}</td>
                    <td>
                      <img src={ProfileImg} className="table-image" />
                    </td>
                    <td className="table-data">{tableValue.title}</td>
                    <td className="table-data">{tableValue.des}</td>
                    <td className="table-data">{tableValue.name}</td>
                    <td className="table-center-data">{tableValue.no}</td>
                    <td className="table-data">burnside</td>
                    <td className="table-data">burnside</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-center-data">{tableValue.hr}</td>
                    <td className="table-data">
                      <div
                        className="table-data--button"
                        style={{
                          backgroundColor:
                            tableValue.status === "Complated"
                              ? "#D2FFEB"
                              : "#FFB0B0",
                        }}
                      >
                        <p
                          className="table-data--button-title"
                          style={{
                            color:
                              tableValue.status === "Complated"
                                ? "#098B51"
                                : "#B80000",
                          }}
                        >
                          {tableValue.status}
                        </p>
                      </div>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={handleDropdownChange}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default CourseHistory;
